import React from 'react';
import SidePanel from '@ajat/design-system/SidePanel';
import './SizeGuide.css';

/* Content-only list — reused by the SidePanel drawer and the HelpCenter page */
export const SizeGuideContent = ({ items = [] }) => (
  <div className="sg-content">
    {items.map((item, index) => (
      <div
        className={`sg-item${index < items.length - 1 ? ' sg-item--border' : ''}`}
        key={item.name}
      >
        <div className="sg-item__image">
          <img src={item.image} alt={item.name} />
        </div>
        <div className="sg-item__details">
          <h4 className="sg-item__name typo-h4">{item.name}</h4>
          <div className="sg-item__sizes">
            {item.sizes.map((size, si) => (
              <div className="sg-item__size-group" key={si}>
                <h6 className="sg-item__size-label typo-h6">{size.label}</h6>
                <p className="sg-item__size-values typo-body-sm">{size.values}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

/* overrideHtml: admin-authored per-product HTML (products.sizeguide_override,
 * BE "Sizeguide content override" field). When present it REPLACES the brand's
 * standard item list; it reuses the sg-* classes so it inherits this design. */
const SizeGuide = ({ isOpen, onClose, title = 'Size Guide', items = [], overrideHtml = null }) => (
  <SidePanel isOpen={isOpen} onClose={onClose} title={title}>
    {overrideHtml ? (
      // eslint-disable-next-line react/no-danger
      <div className="sg-content" dangerouslySetInnerHTML={{ __html: overrideHtml }} />
    ) : (
      <SizeGuideContent items={items} />
    )}
  </SidePanel>
);

export default SizeGuide;
